var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    { ref: "modal", attrs: { bgcolor: "rgba(0,0,0,0.3)", closeable: false } },
    [
      _c(
        "div",
        { staticClass: "tour-guide-modal" },
        [
          _vm.step === 1
            ? _c("Form", { on: { submit: _vm.onSubmit, hide: _vm.hide } })
            : _vm.step === 2
            ? _c("Ringing", {
                attrs: { "form-data": _vm.formData },
                on: { hide: _vm.hide, showCalendar: _vm.showCalendar },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }